import { useAppSelector, useAppDispatch } from '../store/index'
import { login, logout, setUser } from '../store/slices/authSlice'
import { User, UserRole } from '../types/index'

export interface UseAuthReturn {
  user: User | null
  token: string | null
  refreshToken: string | null
  isAuthenticated: boolean
  isLoading: boolean
  error: string | null
  role: UserRole | null
  hasRole: (role: UserRole | UserRole[]) => boolean
  hasAnyRole: (roles: UserRole[]) => boolean
  isPatient: boolean
  isTherapist: boolean
  isAdmin: boolean
  isCertificateManager: boolean
  login: (user: User, token: string, refreshToken: string) => void
  logout: () => void
  updateUser: (user: User) => void
}

export const useAuth = (): UseAuthReturn => {
  const dispatch = useAppDispatch()
  const { user, token, refreshToken, isAuthenticated, isLoading, error } =
    useAppSelector(state => state.auth)

  const role = user?.role || null

  const hasRole = (requiredRole: UserRole | UserRole[]): boolean => {
    if (!user?.role) return false
    if (Array.isArray(requiredRole)) return requiredRole.includes(user.role)
    return user.role === requiredRole
  }

  const hasAnyRole = (roles: UserRole[]): boolean => {
    if (!user?.role) return false
    return roles.includes(user.role)
  }

  const isPatient = user?.role === UserRole.CLIENT
  const isTherapist = user?.role === UserRole.THERAPIST
  const isAdmin = user?.role === UserRole.ADMIN
  const isCertificateManager = user?.role === UserRole.CERTIFICATE_MANAGER

  /**
   * Login wrapper now dispatches the unified login action
   */
  const handleLogin = (userData: User, authToken: string, refreshTokenData: string) => {
    dispatch(
      login({
        user: userData,
        token: authToken,
        refreshToken: refreshTokenData,
      })
    )
  }

  /**
   * Logout wrapper
   */
  const handleLogout = () => {
    dispatch(logout())
  }

  /**
   * Update user data manually
   */
  const updateUser = (userData: User) => {
    dispatch(setUser(userData))
  }

  return {
    user,
    token,
    refreshToken,
    isAuthenticated,
    isLoading,
    error,
    role,
    hasRole,
    hasAnyRole,
    isPatient,
    isTherapist,
    isAdmin,
    isCertificateManager,
    login: handleLogin,
    logout: handleLogout,
    updateUser,
  }
}

export default useAuth


// import { useAppSelector, useAppDispatch } from '../store/index'
// import { logout, setUser, setToken } from '../store/slices/authSlice'
// import { User, UserRole } from '../types/index'

// export interface UseAuthReturn {
//   user: User | null
//   token: string | null
//   isAuthenticated: boolean
//   isLoading: boolean
//   error: string | null
//   role: UserRole | null
//   hasRole: (role: UserRole | UserRole[]) => boolean
//   hasAnyRole: (roles: UserRole[]) => boolean
//   isPatient: boolean
//   isTherapist: boolean
//   isAdmin: boolean
//   login: (user: User, token: string) => void
//   logout: () => void
//   updateUser: (user: User) => void
// }

// /**
//  * Custom hook for authentication state management
//  * Provides centralized access to user authentication state and role-based utilities
//  */
// export const useAuth = (): UseAuthReturn => {
//   const dispatch = useAppDispatch()
//   const { user, token, isAuthenticated, isLoading, error } = useAppSelector(
//     state => state.auth
//   )

//   const role = user?.role || null

//   /**
//    * Check if user has a specific role or any of the provided roles
//    */
//   const hasRole = (requiredRole: UserRole | UserRole[]): boolean => {
//     if (!user || !user.role) return false

//     if (Array.isArray(requiredRole)) {
//       return requiredRole.includes(user.role)
//     }

//     return user.role === requiredRole
//   }

//   /**
//    * Check if user has any of the provided roles
//    */
//   const hasAnyRole = (roles: UserRole[]): boolean => {
//     if (!user || !user.role) return false
//     return roles.includes(user.role)
//   }

//   /**
//    * Convenience getters for common role checks
//    */
//   const isPatient = user?.role === UserRole.CLIENT
//   const isTherapist = user?.role === UserRole.THERAPIST
//   const isAdmin = user?.role === UserRole.ADMIN

//   /**
//    * Login action wrapper
//    */
//   const handleLogin = (userData: User, authToken: string) => {
//     dispatch(setUser(userData))
//     dispatch(setToken(authToken))
//   }

//   /**
//    * Logout action wrapper
//    */
//   const handleLogout = () => {
//     dispatch(logout())
//   }

//   /**
//    * Update user data
//    */
//   const updateUser = (userData: User) => {
//     dispatch(setUser(userData))
//   }

//   return {
//     user,
//     token,
//     isAuthenticated,
//     isLoading,
//     error,
//     role,
//     hasRole,
//     hasAnyRole,
//     isPatient,
//     isTherapist,
//     isAdmin,
//     login: handleLogin,
//     logout: handleLogout,
//     updateUser,
//   }
// }

// export default useAuth
